import React, { useContext } from 'react';
import styled from 'styled-components';
import { bool } from 'prop-types';
import Switch from '@mui/material/Switch';
import { makeStyles } from '@mui/styles';
import { LocaleContext } from 'routes/Router';

const WrapperDiv = styled.div`
  width: 60px;
  height: 40px;
  display: flex;
  align-items: center;

  .MuiSwitch-root {
    width: 60px;
    height: 40px;
    padding: 7px;
  }

  .MuiSwitch-switchBase {
    padding: 6px;
    &.Mui-checked {
      transform: translateX(26px);
      color: #fff;

      & + .MuiSwitch-track {
        background-color: green;
        opacity: 1;
      }
    }
  }

  .MuiSwitch-thumb {
    width: 20px;
    height: 22px;
    margin-top: 3px;
  }

  .MuiSwitch-track {
    border-radius: 17px;
    background-color: #ccc;
    opacity: 1;
  }
`;

const useStyles = makeStyles({
  root: {
    width: 60,
    height: 50,
    padding: 7,
  },

  switchBase: {
    '&$checked': {
      transform: 'translateX(26px)',
    },
  },

  thumb: {
    width: 26,
    height: 26,
    marginTop: 3,
  },

  track: {
    borderRadius: 17,
    backgroundColor: '#ccc',
    opacity: 1,
    '$checked + &': {
      backgroundColor: 'green',
    },
  },

  checked: {},
});

function SwitchList({ onText, offText, label, checked, ...props }) {
  const { locale } = useContext(LocaleContext);
  const classes = useStyles();

  return (
    <WrapperDiv locale={locale} {...props}>
      <Switch
        checked={checked}
        classes={{
          root: classes.root,
          switchBase: classes.switchBase,
          thumb: classes.thumb,
          track: classes.track,
          checked: classes.checked,
        }}
        {...props}
      />
    </WrapperDiv>
  );
}

SwitchList.propTypes = {
  checked: bool.isRequired,
};

SwitchList.defaultProps = {
  checked: false,
};

export default SwitchList;
